module.exports = __webpack_public_path__ + "static/media/DaciaSpirit-BlackV1500Latin-Cyrillic.f32a9bf9.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/spirit/DaciaSpirit-BlackV1500Latin-Cyrillic.woff
// module id = 658
// module chunks = 0